import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const NabhBilling = () => {
  return (
    <section id="nabh-billing" className="landing billing-landing">
      <Helmet>
        <title>NABH & CGHS Billing Software India — Mediway Nextgen</title>
        <meta name="description" content="Optimized NABH billing software, CGHS rate management, and insurance TPA processing for hospitals in India. Try Mediway Nextgen billing modules free." />
        <link rel="canonical" href="https://mediwaynextgen.wayug.com/features/nabh-medical-billing" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'SoftwareApplication',
            'name': 'NABH & CGHS Billing Software',
            'description': 'Automated, compliance-ready NABH & CGHS medical billing system with TPA insurance integrations for Indian hospitals.',
            'brand': 'Mediway Nextgen',
            'url': 'https://mediwaynextgen.wayug.com/features/nabh-medical-billing',
            'applicationCategory': 'BillingApplication'
          })}
        </script>
      </Helmet>

      <div className="container">
        <header className="section-header">
          <h2 className="section-title">NABH &amp; CGHS Billing Software — Seamless Compliance</h2>
          <p className="section-subtitle">Simplify Indian healthcare insurance, TPA workflows, corporate rate packages, and NABH compliance reporting with automated billing tools.</p>
        </header>

        <div className="service-content">
          <div className="service-header">
            <div className="service-icon">🧾</div>
            <div className="service-info">
              <h3 className="service-title">Transparent Medical Billing</h3>
              <p className="service-description">Ensure error-free processing of patient bills, discount codes, package deals, and complex government corporate contracts without manual accounting leaks.</p>
            </div>
          </div>

          <div className="service-body">
            <div className="service-features">
              <h4>Key Billing Modules</h4>
              <ul className="features-list">
                <li className="feature-item"><span className="feature-check">✓</span><span>Auto-mapped CGHS &amp; ECHS rate lists</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>TPA Pre-auth &amp; corporate insurance claims</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Standardized NABH Quality reporting formats</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Consolidated IPD discharge billing arrays</span></li>
              </ul>
            </div>

            <div className="service-benefits">
              <h4>Benefits</h4>
              <div className="benefits-grid">
                <div className="benefit-card"><div className="benefit-icon">🛡️</div><span>Zero revenue leakage</span></div>
                <div className="benefit-card"><div className="benefit-icon">⏳</div><span>Fast TPA approvals</span></div>
                <div className="benefit-card"><div className="benefit-icon">📈</div><span>99.9% Auditable bills</span></div>
              </div>
            </div>
          </div>

          <div className="service-actions">
            <Link to="/contact" className="btn btn-primary">Request Billing Demo</Link>
            <Link to="/services" className="btn btn-secondary">View All Modules</Link>
          </div>
        </div>
      </div>

      <div className="services-background">
        <div className="background-pattern"></div>
      </div>
    </section>
  );
};

export default NabhBilling;
